module.exports = __webpack_public_path__ + "assets/img/d3e5-py.svg";